import { handleErrors } from "../util/api-utils";

export async function sendOtpText(successCallback, errorCallback, finallyCallback) {
    fetch("/api/Otp/SendOtpText", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback)
        .finally(finallyCallback);
};

export async function sendOtpEmail(successCallback, errorCallback, finallyCallback) {
    fetch("/api/Otp/SendOtpEmail", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback)
        .finally(finallyCallback);
};

export async function authenticateOtp(request, successCallback, errorCallback, finallyCallback) {
    fetch("/api/Otp/AuthenticateOtp", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch((error) => errorCallback(error?.body))
        .finally(finallyCallback);
};